import { z } from 'zod'

export const MEMBERSHIP_SCIM_WEBHOOK_CONTRACT_VERSION = '1.0.0' as const

export const membershipScimWebhookResponseSchema = z.record(z.unknown())

export type MembershipScimWebhookResponse = z.infer<typeof membershipScimWebhookResponseSchema>
